import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getCities(filters) {
  return (await Axios.get(`${proxyName}/${Urls.City}`, { params: filters }))
    .data;
}
